import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import '../../assets/css/main.css';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Grid,
  Stack,
  TextField,
  Typography,
  styled,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DateRangePicker, Divider } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';
import CircularProgressBar from 'ui-component/CircularProgressBar';
// import HistoryList from './HistoryList';
// import TransactionHistory from './TransactionHistory';
import getAxiosInstance from 'api';
import moment from 'moment';
import toast from 'react-hot-toast';
import { getDateRangeFromQuickOption } from 'utils/common';
import MainCard from 'ui-component/cards/MainCard';
import ErrorLog from './errorLog';

const StyledCard = styled(Card)(({ theme }) => ({
  padding: '24px',
  boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.06)',
  borderRadius: '12px',
  border: '1px solid rgba(0, 0, 0, 0.1)',
}));

const StyledCallCard = styled(MainCard)(({ theme }) => ({
  // height: '430px',
  border: `1px solid ${theme.palette.divider}`,
}));

const DateRangeButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#fff',
  color: theme.palette.dark.main,

  border: '1px solid rgba(0, 0, 0, 0.1)',
  borderRadius: '8px',
  padding: '8px 16px',
  textTransform: 'none',
  fontWeight: 400,
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
}));

const type = [
  { label: 'All', value: '' },
  { label: 'User', value: 'User' },
  { label: 'Online', value: 'Online' },
  { label: 'API', value: 'API' }
];

const quickRanges = [
  { label: 'Current Day', value: 'day' },
  { label: 'Current Week', value: 'week' },
  { label: 'Current Month', value: 'month' },
  { label: 'Last 3 Months', value: '3months' },
  { label: 'Last 6 Months', value: '6months' },
  { label: 'Last 12 Months', value: '12months' },
  { label: 'Quarter to date', value: '4months' },
  { label: 'All Time', value: '12months' },
];

const Errors = () => {
  const theme = useTheme();

  const [customerDate, setCustomerDate] = useState([
    moment().startOf('month').toDate(),
    moment().toDate(),
  ]);

  const [errorChartData, setErrorChartData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [loadingCustomers, setLoadingCustomers] = useState(false);
  const [quickRangeValue, setQuickRangeValue] = useState('');

  useEffect(() => {
    fetchCustomerCount();
  }, [customerDate]);
  const fetchCustomerCount = () => {
    setLoadingCustomers(true);
    getAxiosInstance(
      `adminOrchestrator/app/getConsentErrorCount`,
      'post',
      {
        startDate: moment(customerDate[0]).format('YYYY-MM-DD'),
        endDate: moment(customerDate[1]).format('YYYY-MM-DD'),
      },
      { 'journey-type': 'Error-Dashboard' }
    )
      .then((res) => {
        if (res?.data?.codes === 200) {
          setLoadingCustomers(false);
          setErrorData(res.data.data);
          setErrorChartData([
            {
              title: 'Total',
              value: res.data.data.totalCount,
              progress: 100,
            },
            {
              title: 'API',
              value: res.data.data.APIErrorCount,
              progress:
                (res.data.data.APIErrorCount / res.data.data.totalCount) *
                  100 || 0,
              isDrillDown: true,
              route: 'api',
              tableName: 'API Errors',
              filterType: 'API',
            },
            {
              title: 'Dashboard ',
              value: res.data.data.onlineErrorCount,
              progress:
                (res.data.data.onlineErrorCount / res.data.data.totalCount) *
                  100 || 0,
              isDrillDown: true,
              route: 'dashboard',
              tableName: 'Dashboard Errors',
              filterType: 'Online',
            },
            {
              title: 'Connect Dashboard',
              value: res.data.data.userErrorCount,
              progress:
                (res.data.data.userErrorCount / res.data.data.totalCount) *
                  100 || 0,
              isDrillDown: true,
              route: 'connect-dashboard',
              tableName: 'Connect Dashboard Errors',
              filterType: 'User',
            },
          ]);
        }
      })
      .catch((err) => {
        setLoadingCustomers(false);
        toast.error(err?.response?.data?.message);
      });
  };
  const navigate = useNavigate();

  const handleViewDrilldown = (route) => {
    navigate(`/calls/${route}`);
  };

  const handleUserViewDrilldown = (item) => {
    navigate(`/errors/${item?.route}`, {
      state: {
        tableName: item.tableName,
        filterType: item.filterType,
        dateRange: customerDate,
      },
    });
  };

  return (
    <Box sx={{ p: 0 }}>
      <Box mt={2}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            rowGap: 1.5,
            mb: 3,
          }}
        >
          <Typography variant="h3">Error</Typography>
          <Box
            sx={{
              display: 'flex',
              gap: 2,
              alignItems: 'center',
              flexWrap: 'wrap',
              justifyContent: 'flex-end',
            }}
          >
            <FormControl size="small" sx={{ width: 170 }}>
              <Select
                value={quickRangeValue || ''}
                onChange={(event) => {
                  const newValue = event.target.value;
                  setQuickRangeValue(newValue);
                  if (!newValue) return;
                  const range = getDateRangeFromQuickOption(newValue);
                  if (!range) return;
                  setCustomerDate([range.start, range.end]);
                }}
                displayEmpty
                inputProps={{ 'aria-label': 'Quick Range' }}
                sx={{
                  backgroundColor: '#fff',
                  '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'rgba(0, 0, 0, 0.23)',
                  },
                }}
              >
                <MenuItem value="">Quick Range</MenuItem>
                {quickRanges.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <DateRangePicker
              appearance="default"
              placeholder="Select Date Range"
              value={customerDate}
              onChange={(value) => {
                setCustomerDate({
                  0: value[0],
                  1: value[1],
                });
                setQuickRangeValue('');
              }}
              showOneCalendar
            />
          </Box>
        </Box>
        <StyledCard>
          {loadingCustomers ? (
            <Box display="flex" justifyContent="center" py={5}>
              <CircularProgress color="secondary" />
            </Box>
          ) : (
            <Grid container spacing={4} justifyContent="center">
              {errorChartData.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={3}
                  key={index}
                  sx={{ textAlign: 'center' }}
                >
                  <Box sx={{ maxWidth: 200, margin: '0 auto' }}>
                    <CircularProgressBar
                      width={100}
                      size={150}
                      title={item?.subtitle}
                      value={item?.value}
                      progress={item?.progress}
                      header={item?.title}
                    />
                    {item?.isDrillDown && (
                      <Button
                        variant="text"
                        onClick={() => handleUserViewDrilldown(item)}
                        startIcon={<KeyboardArrowUpIcon />}
                        sx={{
                          color: '#FC5719',
                          textTransform: 'none',
                          fontSize: '14px',
                          fontWeight: 400,
                          '&:hover': {
                            backgroundColor: 'transparent',
                          },
                        }}
                      >
                        View Drilldown
                      </Button>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          )}
        </StyledCard>
      </Box>
      <Box mt={4}>
        <Grid
          item
          xs={12}
          md={6}
          display={'flex'}
          justifyContent={'space-between'}
        >
          <StyledCallCard>
            <Stack direction="column">
              <Stack>
                <Box>
                  <Typography variant="h3">Consent Errors</Typography>
                </Box>
              </Stack>
              <Divider mt={1} />
              <Box
                display="flex"
                flexDirection="column"
                spacing={2}
                minWidth={400}
              >
                <Typography variant="body2" fontSize={18}>
                  Incorrect OTP: {errorData?.incorrectOTPCount}
                </Typography>
                <Typography variant="body2" fontSize={18}>
                  Other Consent Error: {errorData?.otherConsentErrorCount}
                </Typography>
                <Typography variant="body2" fontSize={18}>
                  Incorrect account: {errorData?.invalidAccountCount}
                </Typography>
                <Typography variant="body2" fontSize={18}>
                  expiredOTPCount: {errorData?.expiredOTPCount}
                </Typography>
              </Box>
            </Stack>
          </StyledCallCard>
          <StyledCallCard>
            <Stack direction="column">
              <Stack>
                <Box>
                  <Typography variant="h3">Fulfilment Errors</Typography>
                </Box>
              </Stack>
              <Divider mt={1} />
              <Box
                display="flex"
                flexDirection="column"
                spacing={2}
                minWidth={400}
              >
                <Typography variant="body2" fontSize={18}>
                  Insufficient Fund : {errorData?.insufficientFundCount}
                </Typography>
                <Typography variant="body2" fontSize={18}>
                  Transaction Not Found : {errorData?.transactionNotFoundCount}
                </Typography>
                <Typography variant="body2" fontSize={18}>
                  Other Transaction Error :{' '}
                  {errorData?.otherTransactionErrorCount}
                </Typography>
              </Box>
            </Stack>
          </StyledCallCard>
        </Grid>
      </Box>
      <Box mt={4}>
        <ErrorLog />
      </Box>
    </Box>
  );
};
export default Errors;
